$(document).ready(function(){
    $(".btn-toBottom, .btn-toBottom1").click(function() { 
        $('html, body').animate({
            scrollTop: $("#contactFormWrapper").offset().top - 200
        }, 1000); 
    });

  $('.rating-stars').each(function () {

    const rating = Math.round((4.5 + Math.random() * 0.5) * 10) / 10;
    const percent = (rating - 4) * 100;

    $(this).html(`
    ★★★★
    <span class="partial">
        ★
        <span style="width:${percent}%">★</span>
    </span>
    `);

  });

});


